// Generated by ts-to-zod
import { z } from "zod";

export const approvalTypeSchema = z.union([
  z.literal("Standard"),
  z.literal("Permit"),
  z.literal("Permit2"),
]);

export const availabilityResponseSchema = z.object({
  isAvailable: z.boolean(),
  canBuy: z.boolean(),
  canSell: z.boolean(),
});

export const chainInfoResponseSchema = z.object({
  chainId: z.number(),
  contractAddress: z.string(),
  decimals: z.number(),
});

export const fullTokenApiResponseSchema = z.object({
  name: z.string(),
  ticker: z.string(),
  availability: availabilityResponseSchema,
  priceUsd: z.number().optional().nullable(),
  cid: z.string(),
  displayDecimals: z.number().optional().nullable(),
  colour: z.string().optional().nullable(),
  permitDomain: z.number(),
  industry: z.string(),
  tokenType: z.string(),
  iconUrl: z.string(),
  minOrderSize: z.number().optional().nullable(),
  chainInfo: z.array(chainInfoResponseSchema),
});

export const gasFeeResponseSchema = z.object({
  native: z.string(),
  usd: z.number().optional().nullable(),
});

export const metadataSchema = z.object({
  lastUpdate: z.string(),
});

export const minSizeFeeSchema = z.object({
  ether: z.number(),
  usd: z.number(),
});

export const orderApiResponseSchema = z.object({
  txHash: z.string(),
  status: z.string(),
  expiry: z.number(),
});

export const permitSchema = z.object({
  signature: z.string(),
  approvals_deadline: z.number(),
});

export const permit2Schema = z.object({
  signature: z.string(),
  approvals_deadline: z.number(),
  token_addresses: z.array(z.string()),
  token_nonces: z.array(z.number()),
});

export const quoteToSignApiResponseSchema = z.object({
  expiry: z.number(),
  taker_address: z.string(),
  maker_addresses: z.array(z.string()),
  maker_nonces: z.array(z.number()),
  taker_tokens: z.array(z.array(z.string())),
  maker_tokens: z.array(z.array(z.string())),
  taker_amounts: z.array(z.array(z.string())),
  maker_amounts: z.array(z.array(z.string())),
  receiver: z.string(),
  commands: z.string(),
});

export const responseBuyTokenSchema = z.object({
  amount: z.string(),
  decimals: z.number(),
  priceUsd: z.number(),
  symbol: z.string(),
  price: z.number().optional().nullable(),
  priceBeforeFee: z.number().optional().nullable(),
  amountBeforeFee: z.string(),
});

export const responseSellTokenSchema = z.object({
  amount: z.string(),
  decimals: z.number(),
  priceUsd: z.number(),
  symbol: z.string(),
  price: z.number().optional().nullable(),
  priceBeforeFee: z.number().optional().nullable(),
});

export const tokenApiResponseSchema = z.object({
  name: z.string(),
  ticker: z.string(),
  availability: availabilityResponseSchema,
  priceUsd: z.number().optional().nullable(),
  chainId: z.number(),
  contractAddress: z.string(),
  decimals: z.number(),
});

export const tokenInfoApiResponseSchema = z.object({
  tokens: z.record(tokenApiResponseSchema),
});

export const tokensApiResponseSchema = z.object({
  tokens: z.record(fullTokenApiResponseSchema),
  metadata: metadataSchema,
});

export const txDataSchema = z.object({
  from: z.string().nullable(),
  to: z.string(),
  value: z.string(),
  data: z.string(),
});

export const validationErrorSchema = z.object({
  loc: z.array(z.union([z.string(), z.number()])),
  msg: z.string(),
  type: z.string(),
});

export const apiErrorSchema = z.object({
  errorCode: z.number(),
  message: z.string().optional().nullable(),
  fee: minSizeFeeSchema.optional().nullable(),
});

export const errorApiResponseSchema = z.object({
  error: apiErrorSchema,
});

export const hTTPValidationErrorSchema = z.object({
  detail: z.array(validationErrorSchema).optional(),
});

export const orderApiRequestSchema = z.object({
  quote_id: z.string(),
  signature: z.string(),
  sign_scheme: z.string().optional(),
  permit2: permit2Schema.optional().nullable(),
  permit: permitSchema.optional().nullable(),
});

export const quoteApiResponseSchema = z.object({
  type: z.string(),
  status: z.string(),
  quoteId: z.string(),
  chainId: z.number(),
  approvalType: approvalTypeSchema,
  nativeToken: z.string(),
  taker: z.string(),
  receiver: z.string(),
  isNewReceiver: z.boolean(),
  expiry: z.number(),
  gasFee: gasFeeResponseSchema,
  buyTokens: z.record(responseBuyTokenSchema),
  sellTokens: z.record(responseSellTokenSchema),
  requiredSignatures: z.array(z.string()),
  toSign: quoteToSignApiResponseSchema,
  tx: txDataSchema.optional().nullable(),
});
